import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert } from 'react-bootstrap'
import { useQuery } from '@tanstack/react-query'
import fetch from 'lib/fetch'

import { setActiveModal } from 'registry/actions'
import { GOAL_STATES, GOALS } from 'registry/constants'
import {
  checkoutWithHelloBabyBoxPath,
  apiV3RegistrySetupGoalsPath,
} from 'lib/urls'

import {
  getDevicePlatform,
  getIsDotcomHbbAvailable,
  getHelloBabyBoxQualificationGoals,
  getReceivingHelloBabyBox,
  getRegistryId,
  getRegistrySetupGoal,
  getUserOwnsRegistry,
} from 'registry/reducers'

import { updateSetupProgressGoals } from 'registry/actions'
import QualifiedBody from './qualified-body'
import ReceivingBody from './receiving-body'
import UnqualifiedBody from './unqualified-body'

// @ts-ignore
import css from './hello-baby-box-status.scss'

const PartnerQualifiedBody = () => (
  <div>
    <p className="mbl">Congrats! You've qualified for a Hello Baby Box!</p>
    <Alert>
      Only the registry owner can complete the final steps to get a Hello Baby
      Box.
    </Alert>
  </div>
)

const HelloBabyBoxStatus = () => {
  const {
    devicePlatform,
    goal,
    isHBBAvailable,
    qualificationGoals,
    receivingHelloBabyBox,
    registryId,
    userOwnsRegistry,
  } = useSelector((state: any) => ({
    devicePlatform: getDevicePlatform(state),
    goal: getRegistrySetupGoal(state, GOALS.helloBabyBox),
    isHBBAvailable: getIsDotcomHbbAvailable(state),
    qualificationGoals: getHelloBabyBoxQualificationGoals(state),
    receivingHelloBabyBox: getReceivingHelloBabyBox(state),
    registryId: getRegistryId(state),
    userOwnsRegistry: getUserOwnsRegistry(state),
  }))

  const dispatch = useDispatch()
  const { isLoading, data } = useQuery({
    queryKey: ['registry-hello-baby-box-qualification-goals', registryId],
    queryFn: () => {
      return fetch(apiV3RegistrySetupGoalsPath(registryId), {
        method: 'GET',
      })
    },
    // always fetch the latest data
    staleTime: 0,
    cacheTime: 0,
  })

  useEffect(() => {
    if (!isLoading && !!data) {
      dispatch(updateSetupProgressGoals(data.goals))
    }
  }, [dispatch, isLoading])

  const dispatchSetActiveModal = (
    modalName: string,
    options: { [k: string]: any }
  ) => {
    dispatch(setActiveModal(modalName, options))
  }

  if (receivingHelloBabyBox) {
    return <ReceivingBody />
  } else if (goal?.state === GOAL_STATES.COMPLETE) {
    if (userOwnsRegistry) {
      return (
        <QualifiedBody
          checkoutPath={checkoutWithHelloBabyBoxPath(registryId)}
          isHBBAvailable={isHBBAvailable}
        />
      )
    } else {
      return <PartnerQualifiedBody />
    }
  } else {
    return (
      <UnqualifiedBody
        devicePlatform={devicePlatform}
        qualificationGoals={qualificationGoals}
        setActiveModal={dispatchSetActiveModal}
      />
    )
  }
}

export default HelloBabyBoxStatus
